<template>
    <Link :href="href" :title="title" class="h-full grow">
        <div
            class="rounded-xl h-full bg-white border active:bg-gray-100 overflow-hidden shadow-lg hover:shadow-xl transition-all hover:border-dgreen flex flex-col"
        >
            <div class="border-b bg-dgreen/5" :class="height">
                <vue-picture
                    :image="image"
                    :style="
                        'mx-auto ' +
                        (cover ? 'object-cover w-full h-full' : 'object-contain w-auto') +
                        ' ' +
                        imagePadding
                    "
                />
            </div>
            <div class="d-prose py-4 px-6">
                <div class="flex flex-col" v-if="heading">
                    <strong>{{ heading }}</strong>
                    <p v-if="description" class="hidden md:blocknot-prose my-1 leading-normal text-sm flex-1" v-html="description"></p>
                </div>
                <div v-else class="flex items-center justify-center">
                    <span>{{ title }}</span>
                    <fa :icon="['fal', 'angle-right']" class="ml-2" />
                </div>
            </div>
        </div>
    </Link>
</template>

<script setup>
defineProps({
    href: {
        type: String,
        required: true,
    },
    heading: {
        type: String,
        required: false,
    },
    title: {
        type: String,
        required: false,
    },
    image: {
        type: Object,
        required: false,
    },
    imagePadding: {
        type: String,
        default: 'p-3',
    },
    description: {
        type: String,
        required: false,
    },
    height: {
        type: String,
        default: 'h-48',
    },
    cover: {
        type: Boolean,
        default: false,
    },
});
</script>
